import React from 'react';
export function PageBannerIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.988 8.939a1 1 0 00-.054-.265.973.973 0 00-.224-.374v-.005l-6-6a1 1 0 00-.283-.191c-.031-.014-.064-.022-.1-.034a.992.992 0 00-.259-.052C14.042 2.011 14.023 2 14 2H6a3 3 0 00-3 3v14a3 3 0 003 3h12a3 3 0 003-3V9c0-.022-.011-.04-.012-.061zM15 5.414L17.586 8H16a1 1 0 01-1-1V5.414zM18 20H6a1 1 0 01-1-1V5a1 1 0 011-1h7v3a3 3 0 003 3h3v9a1 1 0 01-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 16H7a1 1 0 000 2h10a1 1 0 000-2z"
  }));
}